import React, { Component, PropTypes } from 'react';

import './SearchUnitPopOver.scss';

export default class SearchUnitPopOver extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    isMobile: PropTypes.bool,
  };

  render() {
    const { children, onClick, isMobile } = this.props;
    return (
      <div className={`search-unit-popover ${isMobile ? 'search-unit-popover--mobile' : ''}`}>
        <div onMouseDown={onClick} className="search-unit-popover__content">
          { children }
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitPopOver/SearchUnitPopOver.jsx
 **/